( function( $ ) {
 
    $('document').ready(function(){
        $('#print').on('click', function() {
            window.print(); // Déclenche l'impression de la page
          });
        // Burger nav
        $('.toggleMenuJs').on('click', function(){
            $('header').toggleClass('header--menu-is-open');
            // Toggle aria-expanded attribute on click
            $('.main-navigation').toggleClass('menu-is-open');
        });
        console.log('slick ok');
        $('.galerie').slick({
            dots: true,
            prevArrow: '<button type="button" class="slick-prev"><svg xmlns="http://www.w3.org/2000/svg" width="19.243" height="32.828"><path data-name="Tracé 110" d="m17.829 1.414-15 15 15 15" fill="none" stroke="#fff" stroke-width="4"/></svg></button>',
            nextArrow: '<button type="button" class="slick-next"><svg xmlns="http://www.w3.org/2000/svg" width="19.243" height="32.828"><path data-name="Tracé 21" d="m1.415 1.414 15 15-15 15" fill="none" stroke="#fff" stroke-width="4"/></svg></button>'
        });
        // Fonction pour gérer le hover sur les écrans non mobiles
        $('.hoverMobileJs').on('click', function(){
            $(this).toggleClass('active');
        })
    });



$(document).ready(function() {
    // Fonction pour mettre à jour la hauteur de l'en-tête
    function updateHeaderHeight() {
        var headerHeight = $('header').outerHeight(); // Obtenir la hauteur de l'en-tête
        $('html').css('--header-height', headerHeight + 'px').attr('data-header-height', headerHeight); // Définir la variable CSS --header-height
    }
     // Fonction pour ajouter ou supprimer la classe en fonction du défilement
     function toggleMenuFixedClass() {
        if( $('body').hasClass('home')) {
            var scrollPosition = $(window).scrollTop(); // Position de défilement actuelle
            var headerHeight = parseInt($('html').attr('data-header-height')); // Hauteur de l'en-tête
   
            // Si la position de défilement est supérieure à la hauteur de l'en-tête
            if (scrollPosition > headerHeight) {
                $('html').addClass('menu-fixed'); // Ajouter la classe 'menu-fixed'
            } else {
                $('html').removeClass('menu-fixed'); // Sinon, enlever la classe 'menu-fixed'
                updateHeaderHeight()
            }
        }else{
       
            $('html').addClass('menu-fixed'); 
            updateHeaderHeight();
        }

     }
    // Appeler la fonction au chargement de la page
    updateHeaderHeight();
    toggleMenuFixedClass(); // 
    // Appeler la fonction lors du défilement de la page
    $(window).scroll(function() {
        updateHeaderHeight(); // Mettre à jour la hauteur de l'en-tête
        toggleMenuFixedClass(); // 
    });

    //$('.equipe__membre').toggleActiveByDelay(2000);
});
    
$.fn.toggleActiveByDelay = function(interval) {
    var equipeMembres = $(this); // Sélectionne tous les éléments correspondants
    
    // Vérifie si des éléments correspondent à la sélection
    if (equipeMembres.length > 0) {
        var toggleActive = function() {
            var activeIndex = equipeMembres.index(equipeMembres.filter('.active')); // Récupère l'index de l'élément actif
            
            // Supprime la classe active de l'élément actuel
            equipeMembres.eq(activeIndex).removeClass('active');
            
            // Calcule l'index de l'élément suivant
            var nextIndex = (activeIndex + 1) % equipeMembres.length;
            
            // Ajoute la classe active à l'élément suivant
            equipeMembres.eq(nextIndex).addClass('active');
        };
        
        // Appelle la fonction toggleActive toutes les 'interval' millisecondes
        var intervalId = setInterval(toggleActive, interval);
        
        // Retourne l'ID de l'intervalle pour une utilisation ultérieure
        return intervalId;
    } else {
        console.log("Aucun élément correspondant à la sélection");
        return null; // Retourne null si aucun élément n'est trouvé
    }
};

$(function() {
    // Récupérer la hauteur de l'en-tête
    const headerHeight = $('header').outerHeight();

    // Gérer le défilement lorsque vous cliquez sur un lien d'ancre
    $('a').on('click', function(e) {
        // Récupérer l'attribut href du lien
        let target = $(this).attr('href');

        // Vérifier si le lien est une ancre
        if (target && target.charAt(0) === '#') {
            // Empêcher le comportement par défaut du lien
            e.preventDefault();

            // Défiler jusqu'à la position de la section cible avec un décalage en haut de la hauteur de l'en-tête
            $('html, body').animate({
                scrollTop: $(target).offset().top - headerHeight - 60
            }, 800);
        }
    });
});
function addAOSAttributes(element, animation, duration= 3000,delay=0) {
    // Ajoutez les attributs AOS à l'élément
    element.attr('data-aos', animation);
    element.attr('data-aos-duration', duration);
    element.attr('data-aos-delay',delay);
    //element.attr('data-aos-anchor-placement', 'top-bottom');
   AOS.refreshHard();

  }


$('document').ready(function(){

// Sélectionnez tous les éléments avec une classe commençant par ng1Aos-
$('.ng1Aos').each(function() {
if (!$(this).parents('.no-anim').length) {
    // Récupérez toutes les classes commençant par 'ng1Aos-'
    var classes = $(this).attr('class').split(' ');

    // Filtrer les classes qui commencent par 'ng1Aos-'
    var ng1AosClasses = classes.filter(function(className) {
        return className.startsWith('ng1Aos-');
    });

    // Traitez chaque classe 'ng1Aos-'
    ng1AosClasses.forEach(function(className) {

        // Extrait le nom de l'animation et la durée
        var parts = className.split('-');
        var animationNameCamelCase= parts[1]; // Le nom de l'animation
        var duration = parts[2]; // La durée de l'animation
        var delay = parts[3]; // La durée de l'animation
        // Convertir le nom de l'animation en format avec des tirets
        var animationNameWithHyphens = animationNameCamelCase.replace(/([a-z])([A-Z])/g, '$1-$2').toLowerCase();
        // Ajoutez les attributs AOS à chaque élément
        addAOSAttributes($(this), animationNameWithHyphens, duration,delay);
        $(this).removeClass(className);
        $(this).removeClass("ng1Aos");
    }.bind(this)); // assure que "this" se réfère à l'élément actuel
}

});

AOS.init();


});

}( jQuery ) );

document.addEventListener('DOMContentLoaded', function() {
    // Récupérer tous les éléments avec la classe toggleOpenJs
    var togglerElements = document.querySelectorAll('.toggleOpenJs');

    // Parcourir tous les éléments
    togglerElements.forEach(function(togglerElement) {
        // Ajouter un écouteur d'événement de clic à chaque élément
        togglerElement.addEventListener('click', function() {
            // Récupérer la valeur de l'attribut data-elem
            var targetSelector = togglerElement.getAttribute('data-elem');
            
            // Récupérer l'élément cible
            var targetElement = document.querySelector(targetSelector);
            
            // Si l'élément cible existe
            if (targetElement) {
                // Toggle la classe 'open' sur l'élément cible
                targetElement.classList.toggle('open');
            }
        });
    });
});


(function($){
    $(document).ready(function(){
        // Initialisation du carrousel Slick
        $('.ng1-immo-card .slickItemsJs').slick({
            arrows: false,
            dots: false
        });

        // Gestionnaire d'événements pour le bouton 'Next'
        $('body').on("click", ".ng1-immo-card .slick-next", function () {
            $(this).closest('.ng1-immo-card').find('.slickItemsJs').slick('slickNext');
        });

        // Gestionnaire d'événements pour le bouton 'Prev'
        $('body').on("click", ".ng1-immo-card .slick-prev", function () {
            $(this).closest('.ng1-immo-card').find('.slickItemsJs').slick('slickPrev');
        });

        // Initialisation de Hammer.js sur chaque élément .ng1-immo-card
        $('.ng1-immo-card').each(function() {
            var swipeElement = this;
            var hammer = new Hammer(swipeElement);

            // Détecter le balayage vers la gauche (suivant)
            hammer.on('swipeleft', function() {
                $(swipeElement).find('.slickItemsJs').slick('slickNext');
            });

            // Détecter le balayage vers la droite (précédent)
            hammer.on('swiperight', function() {
                $(swipeElement).find('.slickItemsJs').slick('slickPrev');
            });
        });
    });
})(jQuery);
